// extracted by mini-css-extract-plugin
module.exports = {"container":"LadderTeamsDropdown_container_-pXGG","label":"LadderTeamsDropdown_label_LSO-2"};